//----------------------------------------
// Generic print function for all sections
//----------------------------------------
export function printElement(querySelector, context) {
  let element = document.querySelector(querySelector);
  element = element.cloneNode(true);
  const title = document.getElementsByTagName("title")[0].outerHTML;
  if (context === "articleModal") {
    const downloadbtns = element.querySelector(".c-parts-modal__download");
    if (downloadbtns) {
      downloadbtns.parentElement.removeChild(downloadbtns);
    }
  }

  const html =
    `<html><head>${title}<link rel="stylesheet" href="/css/site.min.css" type="text/css" />` +
    `</head><body bgcolor=white" onload="print();"><div class="container">` +
    `<img src="/Content/img/CEJN-logo.svg?v1" style="max-width: 80px;" class="d-inline-block align-top img-fluid logo mb-5 mt-4" alt="CEJN" />` +
    element.innerHTML +
    `</div></body></html>`;
  const w = window.open("", "_blank");
  w.document.write(html);
  w.document.close();
  w.focus();
}

// Assign to window for legacy/global usage
window.printElement = printElement;

//-----------------------------------------------------------------------
// animate in contact form button
//-----------------------------------------------------------------------
window.addEventListener('load', function () {
    if (document.getElementById("contact-form-btn")) {
        setTimeout(function () {
            document.getElementById("contact-form-btn").classList.add("animated");
        }, 1000);
    }
})
    